/** Angular */
import { Injectable } from '@angular/core';
/** Rxjs */
import { Observable } from 'rxjs';
/** Models */
/** Services */
import { BydRhsAbstractService } from '../../../shared/services/byd-rhs-abstract.service';
import { PinTemplate } from '../models/pin-template.model';
import { BydModel } from '@sixense/byd-core-service';
import { PinTemplateInterface } from '../interfaces/pin-template.interface';

@Injectable({
  providedIn: 'root',
})
export class PinsTemplatesService extends BydRhsAbstractService {
  /**
   * Implement inherited abstract member 'path' from BydRhsAbstractService
   */
  public path: string;

  /**
   * Get pins templates.
   *
   * @param projectId The Project ID
   * @param pageIndex Page index.
   * @param elementsPerPage Elements per page.
   * @returns Observable<PinTemplateResponse>
   * @memberof DsPinsUserRightsService
   */
  public getAllPinTemplates(projectId: number, pageIndex = 0, elementsPerPage = 10): Observable<BydModel<PinTemplate>> {
    this.path = `/dspin/v1/projects/${projectId}/pins/word`;
    const headers = this.bydRhsHeadersService.setHeadersWithPagination(elementsPerPage, pageIndex);
    return this.getModels<PinTemplate>({ headers });
  }

  /**
   * Get Pin word template by ID.
   *
   * @param projectId project ID.
   * @param templateId Template ID.
   * @returns Observable of PinTemplate.
   */
  public getPinTemplate(projectId: number, templateId: number): Observable<PinTemplate> {
    this.path = `/dspin/v1/projects/${projectId}/pins/word/${templateId}`;
    return this.get<PinTemplate>();
  }

  /**
   * Download Pin template by ID.
   *
   * @param projectId Project Id.
   * @param templateId Template Id.
   * @returns Observable of Blob.
   */
  public downloadPinTemplate(projectId: number, templateId: number): Observable<Blob> {
    this.path = `/dspin/v1/projects/${projectId}/pins/word/${templateId}/download`;
    return this.get<Blob>({ responseType: 'blob' });
  }

  /**
   * Delete Pin template.
   *
   * @param projectId Project Id.
   * @param templateId Template Id.
   * @returns Observable of boolean.
   */
  public deletePinTemplate(projectId: number, templateId: number): Observable<boolean> {
    this.path = `/dspin/v1/projects/${projectId}/pins/word/${templateId}`;
    return this.delete<boolean>();
  }

  /**
   * Upload pin template.
   *
   * @param projectId Project Id.
   * @param template File to upload
   * @returns observable of PinTemplate
   */
  public uploadPinTemplate(projectId: number, template: File): Observable<PinTemplate> {
    this.path = `/dspin/v1/projects/${projectId}/pins/word`;
    const formData = new FormData();
    formData.append('file', template);
    const headers = this.bydConfigService.headers.delete('Content-Type');
    return this.post<PinTemplate>({ body: formData, headers });
  }

  /**
   * Create Pin Template Response instance.
   *
   * @param jsonObject Template reponse.
   * @returns PinTemplateResponse.
   */
  public createNewInstance(jsonObject: PinTemplateInterface): PinTemplate {
    return new PinTemplate(jsonObject);
  }
}
